import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { Message, ConfirmationService, ConfirmEventType, MenuItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { local } from 'd3';
import { MsPermissionService } from 'src/app/services/ms-permission.service';

@Component({
  selector: 'app-assign-weights',
  templateUrl: './assign-weights.component.html',
  styleUrls: ['./assign-weights.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']
})
export class AssignWeightsComponent {

  isInternalPM: boolean = false;
  statusType: string = '';
  isSkelition = false;
  header: string = this.translate("Assign Weight for channels");
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/project',
    }
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('Assign Weight for channels'), link: '/ms/assign-weights' },
  ];
  messages: Message[] = [];
  projectId: string = '';
  project: any;
  channels: Array<any> = []
  basicChannels: Array<any> = []
  branchChannels: Array<any> = []
  branches: Array<any> = []
  selectedBranches: any[] = [];
  isCheckAll: boolean = false;
  pmComment: string = '';
  stepStatus: any = [];
  hasBranches: boolean = false;
  hasStatusDB: boolean = true;
  invalidWeight: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.projectId = params['projectId'];
      if (this.projectId) {
        this.selectedBranches = [];
        this.branches = [];
        this.basicChannels = [];
        this.getProject(this.projectId).then(() => {

          let pm = MsPermissionService.checkUserPermissions(this.project);
          if (pm == true) {
            this.isInternalPM = true;
          } else if (pm == false) {
            this.router.navigate(['/ms/project'])
            return;
          }

          return Promise.all([
            this.getBranches(),
            this.getStepStatus()
          ]);
        }).then(() => {
          this.isSkelition = false;
        }).catch((error) => {
        });
      }

    })
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  checkAll(checked: boolean) {
    if (!checked) {
      this.isCheckAll = true;
      this.selectedBranches = [...this.branches];
    } else {
      this.isCheckAll = false;
      this.selectedBranches = [];
    }
  }

  addRemoveBranch(branch: any) {
    const index = this.selectedBranches.findIndex(b => b.branchId === branch._id || b._id === branch._id);
    if (index !== -1) {
      this.selectedBranches.splice(index, 1);
    } else {
      this.selectedBranches.push(branch);
    }
  }

  branchSelected(branch: any) {
    return this.selectedBranches.findIndex(b => b.branchId === branch._id || b._id === branch._id) !== -1;
  }

  async getProject(id: string) {
    try {
      this.isSkelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.project = res.data.data;
      this.channels = res.data.channels;
      this.basicChannels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.hasBranches = this.basicChannels.some(channel => channel.name === "Branches");
      this.selectedBranches = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.isSkelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getBranches() {
    this.isSkelition = true;
    try {
      let res = await this.dataService.getData('ou-type/branches');
      if (res.error) return
      this.branches = res.data;
      this.selectedBranches.forEach((selectedBranch, index) => {
        const matchingBranchIndex = this.branches.findIndex(branch => branch._id == selectedBranch.branchId);
        if (matchingBranchIndex !== -1) {
          this.branches[matchingBranchIndex].weight = selectedBranch.weight;
          this.branches[matchingBranchIndex].channelId = selectedBranch._id;
          this.selectedBranches[index].channelId = selectedBranch._id;
        }
      });

      console.log(this.branches);

      this.isSkelition = false;
    } catch (error) {
      console.log(error)
    }
  }

  isWeightValid(): boolean {
    if (this.basicChannels.length > 0) {
      const channelSum = this.basicChannels.reduce((acc, branch) => acc + branch.weight, 0);
      if (channelSum > 100 || channelSum != 100) {
        this.invalidWeight = true;
        return false;
      }
      else {
        this.invalidWeight = false;
      }
    }

    if (this.selectedBranches.length > 0) {
      this.selectedBranches.forEach((selectedBranch, index) => {
        const matchingBranchIndex = this.branches.findIndex(branch => branch._id == selectedBranch.branchId);
        if (matchingBranchIndex !== -1) {
          this.selectedBranches[index].weight = this.branches[matchingBranchIndex].weight
        }
      });
      const branchSum = this.selectedBranches.reduce((acc, branch) => acc + branch.weight, 0);
      if (branchSum > 100 || branchSum != 100) {
        this.invalidWeight = true;
        return false;
      } else {
        this.invalidWeight = false;
      }
    }

    return true;
  }

  async getStepStatus() {
    this.isSkelition = true;
    try {
      let vendorType = (this.isInternalPM || this.isInternalUserPM(this.project.internalPm)) ? 'internal' : 'external';
      let res = await this.dataService.getData('ms-step/project/' + this.projectId + '/Weights/' + vendorType);
      if (res.error) {
        this.hasStatusDB = false;
        return
      }
      this.stepStatus = res.data;

      if (this.stepStatus) {
        this.statusType = this.stepStatus.approvalStatus;
        if (this.statusType == 'Redo' || this.statusType == 'Change') {
          this.pmComment = this.stepStatus.comments;
        }
      }

      console.log("this.statusType", this.statusType);

      this.isSkelition = false;
    } catch (error) {
      console.log(error)
    }
  }

  async pendingStatus() {
    try {
      let approveData: any = {
        projectId: this.projectId,
        approvalStatus: 'Pending',
        comments: this.pmComment,
        step: 'Weights',
        doneBy: localStorage.getItem('uid'),
      };
      this.isSkelition = true;
      let res = await this.dataService.postData('ms-step', approveData);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  }

  approveStatus() {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Approved',
            comments: this.pmComment,
            step: 'Weights',
            doneBy: localStorage.getItem('uid'),
          };
          this.isSkelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  redoStatus() {
    if (this.pmComment == '') {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Redo',
            comments: this.pmComment,
            step: 'Weights',
            doneBy: localStorage.getItem('uid')
          };
          this.isSkelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  submitForApproval() {
    if (this.isWeightValid()) {
      this.confirm({
        message: this.translate('Are you sure you want to do this?'),
        header: this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: async () => {
          let data: any[] = [];
          this.basicChannels.forEach((channel: any) => {
            let channelData: any = {
              _id: channel._id,
              name: channel.name,
              projectId: this.projectId,
              visitCount: channel.visitCount || 0,
              type: "Basic",
              weight: channel.weight || 100
            };
            data.push(channelData);
          });

          this.selectedBranches.forEach((branch: any) => {
            let branchData: any = {
              _id: branch.channelId || null,
              name: branch.name,
              projectId: this.projectId,
              branchId: branch.branchId || branch._id,
              visitCount: branch.visitCount || 0,
              type: "Branch",
              weight: branch.weight || 100
            };
            data.push(branchData);
          });
          let res = await this.dataService.postData('ms-channel/many', data)
          this.pendingStatus();
        },
      });
    }
  }

  requestChange() {
    if (this.pmComment == '') {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Change',
            comments: this.pmComment,
            step: 'Weights',
            doneBy: localStorage.getItem('uid')
          };
          this.isSkelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  async saveWeight() {
    if (this.isWeightValid()) {
      let data: any[] = [];

      this.basicChannels.forEach((channel: any) => {
        let channelData: any = {
          _id: channel._id,
          name: channel.name,
          projectId: this.projectId,
          visitCount: channel.visitCount || 0,
          type: "Basic",
          weight: channel.weight || 0
        };
        data.push(channelData);
      });
      this.selectedBranches.forEach((branch: any) => {
        let branchData: any = {
          _id: branch.channelId || null,
          name: branch.name,
          projectId: this.projectId,
          branchId: branch.branchId || branch._id,
          visitCount: branch.visitCount || 0,
          type: "Branch",
          weight: branch.weight || 0
        };
        data.push(branchData);
      });
      this.isSkelition = true;
      let res = await this.dataService.postData('ms-channel/many', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: this.translate('') },
      ]
      this.ngOnInit();
      return;
    }
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  isInternalUserPM(internalPm: any) {
    const uid: string = localStorage.getItem('uid') ?? '';
    if (internalPm) {
      if (Array.isArray(internalPm) && internalPm.length > 0) {
        return uid === internalPm[0]._id;
      } else if (typeof internalPm === 'object' && internalPm._id) {
        return uid === internalPm._id;
      }
    }
    return false;
  }

}
